<form
  [formGroup]="formGroup"
  (submit)="isFormValid()"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <mat-toolbar fxLayout="row">
    <button
      mat-icon-button
      [matTooltip]="'LABEL_CLOSE' | translate"
      (click)="confirmChanges()"
      type="button"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{
        detail?.id
          ? ('LABEL_EDIT_TYPE'
            | translate : { type: 'LABEL_RECIPIENT' | translate })
          : ('LABEL_ADD_NEW'
            | translate : { type: 'LABEL_RECIPIENT' | translate })
      }}
    </span>
    <span fxFlex></span>
    <button
      mat-icon-button
      [matTooltip]="'LABEL_SAVE' | translate"
      type="submit"
      [disabled]="disableSaveBtn()"
    >
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>

  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- code -->
    <div fxLayout *ngIf="!mode">
      <mat-form-field>
        <input
          #code
          matInput
          autocomplete="off"
          formControlName="code"
          [placeholder]="'LABEL_CODE' | translate"
        />
      </mat-form-field>
    </div>

    <!-- recipient type -->
    <div fxLayout>
      <mat-form-field>
        <mat-select required formControlName="recipient_type">
          <mat-option
            *ngFor="let recipientType of recipientTypes"
            [value]="recipientType.code"
            >{{ recipientType.description }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Doctor Full Name & Social Media Name -->
    <div
      fxLayout
      *ngIf="
        formGroup.get('recipient_type').value === RECIPIENT_DOCTOR ||
        formGroup.get('recipient_type').value === RECIPIENT_SOCIAL
      "
    >
      <mat-form-field>
        <input
          matInput
          required
          #fullname
          autocomplete="off"
          formControlName="fullname"
          [placeholder]="
            (formGroup.get('recipient_type').value === RECIPIENT_DOCTOR
              ? 'LABEL_FULLNAME'
              : 'LABEL_SOCIAL'
            ) | translate
          "
        />

        <mat-error *ngIf="formGroup.get('fullname').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('fullname').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate : { length: '250' } }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('fullname').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Branch Name -->
    <esc-branch-dropdown
      *ngIf="formGroup.get('recipient_type').value === RECIPIENT_BRANCH"
      class="width-100"
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="branchSelected($event)"
      [previousData]="selectedBranch"
      [requiredError]="true"
      [disabled]="loading.submit"
      [isRequired]="true"
    >
    </esc-branch-dropdown>
    <!-- Social Media Name -->

    <!-- reference_code -->
    <div fxLayout>
      <mat-form-field>
        <input
          matInput
          required
          #reference_code
          autocomplete="off"
          formControlName="reference_code"
          [placeholder]="'LABEL_REFERENCE_CODE' | translate"
        />

        <mat-error *ngIf="formGroup.get('reference_code').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error
          *ngIf="formGroup.get('reference_code').hasError('maxlength')"
        >
          {{ 'MSG_MAXLENGTH' | translate : { length: '250' } }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('reference_code').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- email_address -->
    <div fxLayout>
      <mat-form-field>
        <input
          matInput
          required
          #email_address
          autocomplete="off"
          formControlName="email_address"
          [placeholder]="'LABEL_EMAIL_ADDRESS' | translate"
        />

        <mat-error *ngIf="formGroup.get('email_address').hasError('pattern')">
          {{ 'MSG_ERROR_INVALID_EMAIL_FORMAT' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- contact_number -->
    <div fxLayout>
      <mat-form-field>
        <input
          matInput
          #contact_number
          autocomplete="off"
          formControlName="contact_number"
          [placeholder]="'LABEL_CONTACT_NUMBER' | translate"
        />

        <!-- <mat-error *ngIf="formGroup.get('contact_number').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>    -->

        <mat-error *ngIf="formGroup.get('contact_number').hasError('pattern')">
          {{ 'MSG_NUMBERS_ONLY' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- max registration -->
    <ng-container>
      <mat-form-field class="mechanic-field-padding" flex>
        <input
          [id]="'id_max_registration_txtbox'"
          [placeholder]="'LABEL_MAX_REGISTRATION' | translate"
          formControlName="max_registration"
          required
          matInput
        />

        <mat-checkbox
          [id]="'id_max_registration_checkbox'"
          class="example-margin"
          formControlName="max_registration_infinite"
          matSuffix
          class="padding-right-15"
        >
          {{ 'LBL_INFINITE' | translate }}</mat-checkbox
        >

        <mat-error
          *ngIf="formGroup.get('max_registration').hasError('required')"
        >
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('max_registration').hasError('min')">
          {{ 'MSG_MIN' | translate : { quantity: 1 } }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('max_registration').hasError('valid')">
          {{ 'MSG_NUMBERS_ONLY' | translate }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>
  </div>
</form>
